import { SET_ID, REMOVE_ID } from '@/store/actions/edit_ride/cache';

const initialState = { id: '' };

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_ID: {
            const { id } = action.data;
            return { ...state, id };
        }

        case REMOVE_ID: {
            const { id } = action.data;
            return state.id === id ? { ...state, id: '' } : state;
        }

        default: {
            return state;
        }
    }
};
